export default __webpack_public_path__ + "static/icon-twitter--colored-ab9bd55dc08af5f870412d2e32eae134.svg";